import { render } from "./JsonEdit.vue?vue&type=template&id=c8a091ec&scoped=true"
import script from "./JsonEdit.vue?vue&type=script&lang=js"
export * from "./JsonEdit.vue?vue&type=script&lang=js"

import "./JsonEdit.vue?vue&type=style&index=0&id=c8a091ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a091ec"]])

export default __exports__